import { EXPERIENCE_CHAPTERS } from "../data/experience";
import { useExperienceStore } from "../store/experience-store";

interface HudProps {
  readonly onChapterSelect: (index: number) => void;
}

export function Hud({
  onChapterSelect,
}: HudProps): React.JSX.Element {
  const chapterIndex = useExperienceStore((store) => store.chapterIndex);
  const quality = useExperienceStore((store) => store.quality);
  const autoPlay = useExperienceStore((store) => store.autoPlay);

  return (
    <div className="hud">
      <header className="hud-header">
        <button
          className="brand"
          type="button"
          onClick={() => onChapterSelect(0)}
          aria-label="返回开场"
        >
          <img
            className="brand-wordmark"
            src="./brand/showstrong-white.png"
            alt="先创 SHOWSTRONG"
          />
        </button>
        <div className="system-state">
          <span className="presence presence--on" />
          <span>POINTER MODE</span>
          <span>{quality.toUpperCase()}</span>
          <span>{autoPlay ? "AUTO" : "LIVE"}</span>
        </div>
      </header>

      <nav className="chapter-rail" aria-label="展厅章节">
        {EXPERIENCE_CHAPTERS.map((chapter) => (
          <button
            type="button"
            key={chapter.id}
            className={chapter.index === chapterIndex ? "is-active" : ""}
            onClick={() => onChapterSelect(chapter.index)}
            aria-label={`前往${chapter.title}`}
            aria-current={chapter.index === chapterIndex ? "step" : undefined}
          >
            <span>{chapter.marker}</span>
          </button>
        ))}
      </nav>

      <div className="hud-footer">
        <div className="interaction-hint">
          <span className="interaction-icon" aria-hidden="true">
            ◎
          </span>
          <span>SWIPE TO NAVIGATE · PINCH TO ROTATE · SPREAD TO EXPLODE</span>
        </div>
        <span className="chapter-counter">
          {String(chapterIndex).padStart(2, "0")} /{" "}
          {String(EXPERIENCE_CHAPTERS.length - 1).padStart(2, "0")}
        </span>
      </div>
    </div>
  );
}
